import Header from "./Components/Work/Header"
import Projects from "./Components/Work/Projects"
import Testimonial from "./Components/Testimonial"
import CTA from "./Components/CTA"

const Project = () => {
    return (
        <div className="select-none">
            <Header></Header>
            <Projects></Projects>
            {/* <Testimonial></Testimonial> */}
            <CTA></CTA>
        </div>
    )
}

export default Project